// The lister provides another abstraction layer between the implementation
// of that what implements the functionality (e.g. the finder of repositories)
// and how that functionality can be accessed. It provides a getter that can
// be used by our elements. This way the interface to services can always
// be the same, and thus our components always have the same way to access
// a specific service.
import type { IRepository } from "./types";

import RepositoryFinder, { RepositoryServiceContext } from "./finder.js";

class RepositoryLister {
    finder: RepositoryFinder;

    get(name: string): IRepository {
        return this.finder.repositories[name];
    }

    addRepository(repoName: string, repo: IRepository) {
        this.finder.addRepository(repoName, repo);
    }

    findRepositoriesTargetingPathUsingMethod(
        path: RegExp,
        method: string
    ): IRepository[] {
        return this.finder.findRepositoriesTargetingPathUsingMethod(
            path,
            method
        );
    }

    findRepositoriesWithSameLengthPathUsingMethod(
        path: string,
        method: string
    ): IRepository[] {
        return this.finder.findRepositoriesWithSameLengthPathUsingMethod(
            path,
            method
        );
    }

    setFinder(finder: RepositoryFinder) {
        this.finder = finder;
    }

    get context(): RepositoryServiceContext {
        return this.finder.context;
    }

    activateCache() {
        this.finder.cache.activate();
    }

    deactivateCache() {
        this.finder.cache.deactivate();
    }

    clearCache() {
        this.finder.cache.clear();
    }
}

export default RepositoryLister;
